import React, {useMemo} from 'react';
import {
    Route,
    Routes,
    useNavigate,
} from 'react-router-dom';

import OktaAuth, {toRelativeUrl} from '@okta/okta-auth-js';
import {LoginCallback, Security} from '@okta/okta-react';

import {OktaAuthenticationController} from './okta-authentication-controller';

import type {AuthenticationConfig} from 'src/openapi/admin/models/AuthenticationConfig';

type Props = {
    authProvider: AuthenticationConfig,
    children: React.ReactElement,
};

export const OktaAuthenticationEnvironment: React.FC<Props> = ({children, authProvider}) => {
    const navigate = useNavigate();
    const oktaAuth = useMemo<OktaAuth>(() => new OktaAuth({
        issuer: authProvider.config.url,
        clientId: authProvider.config.clientId,
        redirectUri: window.location.origin + '/login/callback',
        scopes: ['openid', 'profile', 'email'],
        tokenManager: {
            autoRenew: true,
        },
    }), [authProvider]);

    const restoreOriginalUri = (_oktaAuth: OktaAuth, originalUri: string) => {
        navigate(toRelativeUrl(originalUri || '/', window.location.origin), {replace: true});
    };

    return (
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
            <OktaAuthenticationController>
                {children}
            </OktaAuthenticationController>
            <Routes>
                <Route path="/login/callback" element={<LoginCallback/>}/>
            </Routes>
        </Security>
    );
};
